
export class UtenteDTO {
  id: string;
  email: string;
  name: string;
  nickname: string;
}
